import {Card, CardBody} from "../../../../../_metronic/_partials/controls";
import React, { useState, useEffect } from "react";
import { ProductModal } from "./ProductModal";
import {postProducts, postProductsToOrder} from "../ordersCrud";
import { mergePaymentFields } from "../utils/paymentSummary";
import { getInventoryQty, getInventoryLabel } from "../utils/inventoryDisplay";
import {useDispatch, useSelector} from "react-redux";
import {cartCountActions} from "../../../../../redux/reducers/cartCount";
import {
    Collapse
  } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FilledInput from "@material-ui/core/FilledInput";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import NumberInput from "../../../../components/NumberInput";

export function ProductBox({product,supplier,company,locations,setShowSnackBar, 
                        getSupplierProductsNameBrand,  setProducts, setPaginationOptions, 
                        searchBrand, searchCategory, paginationOptions,
                        isOrderSummary, setIsCartUpdated, isCartUpdated, orderId, currentOrders, 
                        setCurrentOrders, defaultInvoiceDate, defaultShipDate, order }){

    const [selectedUnit, setSelectedUnit] = useState(product.defaultUnitOfMeasurement.uomId);
    const [showProductModal, setShowProductModal] = useState(false);
    const [expanded2, setExpanded2] = useState(false);
    const [locationsToOrder,setLocationsToOrder] = useState([])
    const [locationList,setLocationList] = useState()
    const [open, setOpen] = React.useState(false);
    const [isLocationsSet, setIsLocationsSet] = useState(false);
    const [dialogMessage, setDialogMessage] = useState("");
    const dispatch = useDispatch();

    const {user,accessToken} = useSelector(
        ({auth}) => ({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    // Helper function to get the appropriate price field based on user role
    const getProductPrice = (product) => {
        if(user && user.roles && user.roles.includes("buyer_external")) {
            return product.fob || 0;
        }
        return (product.listPrice || product.listPrice == '') ? product.listPrice : product.price;
    }

    useEffect(() => {
        let currentLocations = []
        locations.forEach((location,index) => {
            let locationObject = {
                _id: location._id,
                locationName: location.locationName,
                locationAddress: location.locationAddress2 ? location.locationAddress1 + " " + location.locationAddress2 : location.locationAddress1,
                locationCity: location.locationCity,
                amount: ""
            }
            currentLocations.push(locationObject)
        })

        setLocationList(currentLocations)
        setLocationsToOrder([])
        setIsLocationsSet(true)
    }, [ locations ])

    function handleExpandClick2() {
        setExpanded2(!expanded2);
    }

    function handleClose() {
        setOpen(false);
        setDialogMessage("")
        
    }

    function handleOpenDialogue(message){
        setDialogMessage(message)
        setOpen(true);
    }

    const addToCart = () => {

        const isFuelFree = company.isFuelFree ? company.isFuelFree : false 
        const shipVia = company.shipVia ? company.shipVia : ""
        
        if(!isOrderSummary){

            if(locationsToOrder.length > 0 && locationsToOrder[0]?.amount > 0){

                const selectedUnitObject = product.unitsOfMeasurement.find(uom => uom.uomId == selectedUnit)

                console.log("Selected Unit: ", selectedUnitObject)
                let finalProduct = {
                    ...product,
                    selectedUnit: selectedUnitObject ? selectedUnitObject : product.defaultUnitOfMeasurement
                }

                postProducts(user.id, accessToken,locationsToOrder,finalProduct,supplier._id,supplier.entityName,company._id,company.businessName, isFuelFree, shipVia ).then(response =>{
                    if(response.status === 200){
                        dispatch(cartCountActions.getProductCount(accessToken, user.id))
                        setShowSnackBar(true)
                        
                        let locationListAmountZero = locationList.map(location => {
                            return {
                                ...location,
                                amount : ""
                            }
                        })
        
                        setExpanded2(!expanded2)
        
                        setLocationsToOrder([])
                        setLocationList([...locationListAmountZero])

                        const ItemUpdated = {
                            ...product,
                            amount: locationsToOrder[0].amount,
                        }

                        let itemUpdatedPrice = getProductPrice(ItemUpdated)

                        let updatedOrder = {...response.data}

                        if(!updatedOrder.comment){
                            updatedOrder.comment = ""
                        }
                        if(!updatedOrder.customerPo){
                            updatedOrder.customerPo = ""
                        }
                        if(!updatedOrder.shipVia){
                            updatedOrder.shipVia = shipVia
                        }
                        if(!updatedOrder.invoiceDate){
                            updatedOrder.invoiceDate = defaultInvoiceDate
                        }
                        if(!updatedOrder.shipDate){
                            updatedOrder.shipDate = defaultShipDate
                        }
                        

                        let newCurrentOrders = [...currentOrders]

                        const currOrderFoundIndex = newCurrentOrders.findIndex(currOrder => currOrder._id == updatedOrder._id)
                        // Only add new product to order dont alter other changes already made. 

                        if(currOrderFoundIndex >= 0){
                            // console.log("Added product: ", product)
                            let currOrder = {...newCurrentOrders[currOrderFoundIndex]}

                            console.log("Updated order: ", updatedOrder)

                            const productFoundInOrderIndex = currOrder.products.findIndex(item => item._id == product._id)
                            
                            const newProduct = updatedOrder.products.find(item => item._id == product._id)
                            const newProductConversionFactor = newProduct.selectedUnit.conversionFactor ? newProduct.selectedUnit.conversionFactor : 1

                            console.log("New product: ", newProduct)
                            if(productFoundInOrderIndex >= 0){
                                const oldProduct = currOrder.products[productFoundInOrderIndex]
                                const oldProductConversionFactor = oldProduct.selectedUnit.conversionFactor ? oldProduct.selectedUnit.conversionFactor : 1
                                console.log("Old product: ", oldProduct)

                                if(newProduct.isCatchWeight){
                                    if(newProduct.isStaticCatchWeight && newProduct.catchWeights && currOrder.shipVia == "HOME"){
                                        const oldTotalCost = currOrder.totalCost
                                        let oldWeight = oldProduct.catchWeights.length > 0 ? oldProduct?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0
                                        let newTotalCost = oldTotalCost - oldWeight * itemUpdatedPrice
                                        let newWeight = newProduct.catchWeights.length > 0 ? newProduct?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0
                                        newTotalCost += newWeight * itemUpdatedPrice

                                        currOrder.totalCost = Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2
                                    }
                                } else{
                                    
                                    const oldTotalCost = currOrder.totalCost
                                    let newTotalCost = oldTotalCost - oldProduct.amount * oldProductConversionFactor * itemUpdatedPrice
                                    newTotalCost += newProduct.amount * newProductConversionFactor * itemUpdatedPrice

                                    currOrder.totalCost = Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2
                                }
                                
                                const oldTotalAmount = currOrder.totalProductQty
                                let newTotalAmount = oldTotalAmount - oldProduct.amount
                                newTotalAmount += newProduct.amount
                                
                                currOrder.totalProductQty = newTotalAmount
                                currOrder.products[productFoundInOrderIndex].amount = newProduct.amount
                            } else {
                                if(newProduct.isCatchWeight){
                                    if(newProduct.isStaticCatchWeight && newProduct.catchWeights && currOrder.shipVia == "HOME"){
                                        let newWeight = newProduct.catchWeights.length > 0 ? newProduct?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0
                                        let newTotalCost = currOrder.totalCost + newWeight * itemUpdatedPrice
                                        currOrder.totalCost = Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2
                                    }
                                } else{
                                    let newTotalCost = currOrder.totalCost + newProduct.amount * newProductConversionFactor * itemUpdatedPrice
                                    currOrder.totalCost = Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2
                                }
                                
                                let newTotalAmount = currOrder.totalProductQty + newProduct.amount
                                
                                currOrder.totalProductQty = newTotalAmount
                                
                                currOrder.products.push(newProduct)
                            }

                            console.log("Before Bio-Ware if!")
                            if(process.env.REACT_APP_BIOWARE_TENANT == user.tenant){
            
                                console.log("Inside if!")
                                const fuelItem = updatedOrder.products.find(product => product._id == process.env.REACT_APP_FUEL_ID)
                                if(fuelItem){

                                    let products = updatedOrder.products.filter(product => product._id !== fuelItem._id)
            
                                    products.push(fuelItem)
            
                                    currOrder.products = products
                                }
                            }

                            newCurrentOrders[currOrderFoundIndex] = mergePaymentFields(currOrder, updatedOrder)
                        } else{
                            newCurrentOrders.push(updatedOrder)
                        }

                        console.log("New current orders: ", newCurrentOrders)
                        setCurrentOrders(newCurrentOrders)
                    }
                })
            } else{
                handleOpenDialogue("To add to cart amount must be greater than 0.")
            }
        } else{
            let productFound = order.products.find(item => item._id == product._id)
            if(!productFound){
                const selectedUnitObject = product.unitsOfMeasurement.find(uom => uom.uomId == selectedUnit)

                console.log("Selected Unit: ", selectedUnitObject)
                let finalProduct = {
                    ...product,
                    selectedUnit: selectedUnitObject ? selectedUnitObject : product.defaultUnitOfMeasurement
                }
                postProductsToOrder(user.id, accessToken,locationsToOrder,finalProduct,supplier._id,supplier.entityName,company._id,company.businessName, isFuelFree, shipVia, orderId ).then(response =>{
                    if(response.status === 200){
                        dispatch(cartCountActions.getProductCount(accessToken, user.id))
                        setShowSnackBar(true)
        
                        
                        let locationListAmountZero = locationList.map(location => {
                            return {
                                ...location,
                                amount : ""
                            }
                        })
        
                        setExpanded2(!expanded2)
        
                        setLocationsToOrder([])
                        setLocationList([...locationListAmountZero])
    
                        setIsCartUpdated(!isCartUpdated)
                    }
                })
            } else{
                handleOpenDialogue("Item already in order. To change item amount edit in item table.")
            }
            
        }
    }

    const handleAmountInputChange = (locationParam,amount) => {

        let locationToOrderIndex = locationsToOrder.findIndex(location => location._id === locationParam._id)
        let locationInListIndex = locationList.findIndex(location => location._id === locationParam._id)
        let locationsTemp = [...locationsToOrder];
        let locationsListTemp = [...locationList]

        let newAmountParsed = parseInt(amount)

        if(isNaN(newAmountParsed)){
            newAmountParsed = ""
        }

        if(newAmountParsed > 0) {
            if(locationToOrderIndex !== -1) {
                locationsTemp[locationToOrderIndex] = {...locationsTemp[locationToOrderIndex],amount:newAmountParsed}
                locationsListTemp[locationInListIndex] = {...locationsListTemp[locationInListIndex],amount:newAmountParsed}
            } else {
                locationsTemp.push({ ...locationParam , amount:newAmountParsed })
                locationsListTemp[locationInListIndex] = {...locationsListTemp[locationInListIndex],amount:newAmountParsed}
            }
        } else {
            locationsTemp = locationsTemp.filter(location => location._id !== locationParam._id)
            locationsListTemp[locationInListIndex] = {...locationsListTemp[locationInListIndex],amount:newAmountParsed}
        }

        setLocationsToOrder(locationsTemp)
        setLocationList(locationsListTemp)
    }

    return(
        <>
        <div className="col-md-4 cursor-pointer">
            <Card className="d-flex align-items-center mb-9 rounded h-100 shadow-sm" 
                  style={{ 
                      transition: 'all 0.3s ease',
                      border: '1px solid #e1e5e9'
                  }}>
                <CardBody className="p-5 w-100">
                    <div className="row justify-content-center">
                        {/* Product Image */}
                        {product.imagePath && (
                            <div className="col-12 text-center p-3">
                                <img
                                    onClick={() => setShowProductModal(true)}
                                    src={product.imagePath}
                                    alt={product.name}
                                    className="rounded cursor-pointer"
                                    style={{ 
                                        height: "120px", 
                                        width: "120px",
                                        objectFit: 'cover',
                                        transition: 'transform 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                />
                            </div>
                        )}
                        
                        {/* Product Title */}
                        <div onClick={() => setShowProductModal(true)} className="col-12 text-center mt-3">
                            <h3 className="font-weight-bold text-dark mb-2">
                                {product.description ? product.description : product.name}
                            </h3>
                            {/* Show both Item Number and SKU for specific roles, otherwise just SKU */}
                            {product.itemNumber && user && user.roles && 
                             (user.roles.includes("buyer_store") || 
                              user.roles.includes("buyer_external") || 
                              user.roles.includes("buyer_store_admin")) ? (
                                <>
                                    <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                        {`Item Number: ${product.itemNumber}`}
                                    </span>
                                    <div className="col-12 text-center">
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {`Sku: ${product.sku}`}
                                        </span>
                                    </div>
                                </>
                            ) : (
                                <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                    {`Sku: ${product.sku}`}
                                </span>
                            )}
                        </div>

                        {/* Brand - only show for GFR tenant */}
                        {product.brand && user && user.tenant == process.env.REACT_APP_GFR_TENANT && (
                            <div className="col-12 text-center">
                                <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                    {`Brand: ${product.brand}`}
                                </span>
                            </div>
                        )}

                        {/* Product Details - Original Style */}
                        {(() => {
                            const stockQty = getInventoryQty(product, user);
                            return stockQty !== null && !product.isExternal ? (
                                <div className="col-12 text-center">
                                    <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                        {`${getInventoryLabel(product, user)}: ${stockQty}`}
                                    </span>
                                </div>
                            ) : null;
                        })()}
                        
                        {product.defaultUnitOfMeasurement && (
                            <div className="col-12 text-center">
                                <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                    {`Unit Size: ${product.defaultUnitOfMeasurement.name} (${product.defaultUnitOfMeasurement.conversionFactor} EA)`}
                                </span>
                            </div>
                        )}
                        
                        {/*<div className="col-12 text-center">*/}
                        {/*    <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">*/}
                        {/*        {`Units: ${product.units}`}*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                        
                        {/* Pricing Section - Original Style */}
                        {user.roles.includes("buyer_external") ? (
                            <div className={`col-12 text-center mb-3`}>
                                <span className="text-dark font-weight-bolder text-hover-primary font-size-lg label label-lg label-light-primary label-inline">
                                    {`FOB: $${product.fob || 0}`}
                                </span>
                            </div>
                        ) : (
                            <>
                                <div className={`col-12 text-center ${!product.discountPrice && (!product.fob || (supplier && supplier.isExternal === false)) ? 'mb-3' : ''}`}>
                                    {product.listPrice ? (
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg label label-lg label-light-primary label-inline">
                                            {`Regular Price: $${product.listPrice}`}
                                        </span>
                                    ) : (
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {`Regular Price: $${product.price}`}
                                        </span>
                                    )}
                                </div>

                                {product.discountPrice && product.discountPrice !== 0 && (
                                    <div className={`col-12 text-center ${(!product.fob || (supplier && supplier.isExternal === false)) ? 'mb-3' : ''}`}>
                                        <span className="font-size-lg font-weight-bolder mb-1">
                                            <span >{`Discount Price: $${product.discountPrice}`}</span>
                                        </span>
                                    </div>
                                )}

                                {/* Only show FOB for regular users if supplier.isExternal is NOT false */}
                                {product.fob && supplier && supplier.isExternal !== false && (
                                    <div className="col-12 text-center mb-3">
                                        <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                            {`FOB: $${product.fob}`}
                                        </span>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    
                    {/* Add to Cart Button */}
                    {!expanded2 && (
                        <div className="row justify-content-center">
                            <div className="col-12 text-center">
                                <button 
                                    type="button" 
                                    className="btn btn-primary px-4 py-2 font-weight-bold" 
                                    onClick={() => handleExpandClick2()}
                                    style={{
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.transform = 'translateY(-1px)'}
                                    onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                                >
                                    Add to Cart
                                </button>
                            </div>
                        </div>
                    )}
                    
                    {/* Expanded Cart Section - Original Style */}
                    <Collapse in={expanded2} timeout="auto" unmountOnExit>
                        <div className="row justify-content-center mt-1">
                            <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                        {isLocationsSet && locationList.length > 1 ? (
                                            <thead>
                                                <tr className="text-left">
                                                    <th className="pr-0 font-weight-bold">
                                                        Shipping To
                                                    </th>
                                                    <th style={{ minWidth: "150px" }}></th>
                                                </tr>
                                            </thead>
                                        ) : null}
                                        <tbody>
                                            {isLocationsSet ? (
                                                locationList.length > 1 ? (
                                                    locationList.map((location, index) => (
                                                        <tr key={location.locationAddress + '--' + index}>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="bullet bullet-bar bg-success align-self-stretch"></span>
                                                                    <div className="d-flex flex-column flex-grow-1">
                                                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg pl-2">
                                                                            {location.locationName}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td style={{minWidth:"125px"}}>
                                                                <div className="col-12 text-right">
                                                                    <div className="mb-1">
                                                                        <NumberInput
                                                                            value={location.amount}
                                                                            onChange={(e) => handleAmountInputChange(location, e.target.value)}
                                                                            className="form-control form-control-solid h-auto py-2 px-6"
                                                                            min="0"
                                                                            placeholder="0"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr key={locationList[0].locationAddress}>
                                                        <td style={{minWidth:"125px"}}>
                                                            <div className="text-center">
                                                                <div >
                                                                    <NumberInput
                                                                        value={locationList[0].amount}
                                                                        onChange={(e) => handleAmountInputChange(locationList[0], e.target.value)}
                                                                        className="form-control form-control-solid h-auto py-2 px-6"
                                                                        min="0"
                                                                        placeholder="Enter quantity"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            ) : null}
                                            
                                            <tr>
                                                <td>
                                                    {product.unitsOfMeasurement && product.unitsOfMeasurement.length > 1 ? (
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <Select
                                                                value={selectedUnit}
                                                                onChange={(e) => setSelectedUnit(e.target.value)}
                                                                input={
                                                                    <FilledInput
                                                                        name="selectedUnit"
                                                                        id="selectedUnit"
                                                                        className="form-control form-control-solid h-auto py-2 px-6"
                                                                    />
                                                                }
                                                            >
                                                                {product.unitsOfMeasurement.map(uom => (
                                                                    <MenuItem key={uom.uomId} value={uom.uomId}>
                                                                        {`${uom.name} (${uom.conversionFactor})`}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        
                        <div className="row justify-content-center">
                            <div className="col-12 text-center">
                                <button 
                                    type="button" 
                                    className="btn btn-primary px-4 py-2 font-weight-bold" 
                                    onClick={() => addToCart()}
                                    style={{
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.transform = 'translateY(-1px)'}
                                    onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                                >
                                    Add to Cart
                                </button>
                            </div>
                        </div>
                    </Collapse>
                </CardBody>
            </Card>
        </div>
        
        <ProductModal
            modalStatus={showProductModal}
            setShowProductModal ={setShowProductModal}
            product={product}
            locations={locations}
            company={company}
            supplier={supplier}
            setShowSnackBar={setShowSnackBar}
        />

        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                }
            }}
        >
            <DialogTitle id="alert-dialog-title" className="text-center">
                <i className="fas fa-exclamation-triangle text-warning mr-2"></i>
                Alert
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" className="text-center">
                    {dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="justify-content-center pb-3">
                <Button 
                    onClick={handleClose} 
                    variant="contained" 
                    color="primary"
                    className="px-4 py-2"
                    autoFocus
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
        </>
    )
}